import React from 'react';
import { theme } from '../../config/theme';

const Divider = ({ 
  orientation = 'horizontal',
  spacing = 'md',
  className = '' 
}) => {
  const spacingMap = {
    sm: theme.spacing.sm,
    md: theme.spacing.md,
    lg: theme.spacing.lg,
  };

  const horizontalStyles = {
    width: '100%',
    height: '1px',
    backgroundColor: theme.colors.gray[200],
    margin: `${spacingMap[spacing]} 0`,
  };

  const verticalStyles = {
    width: '1px',
    height: '100%',
    backgroundColor: theme.colors.gray[200],
    margin: `0 ${spacingMap[spacing]}`,
  };

  return (
    <div 
      className={className} 
      style={orientation === 'horizontal' ? horizontalStyles : verticalStyles}
    />
  );
};

export default Divider;